var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    key: 'preference' + _vm.key,
    attrs: {
      "margin": 0,
      "flat": "",
      "outlined": "",
      "subtitle": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.registration.registrationAddress.title'),
      "hideTitle": true
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [!_vm.isRegistrationAddress ? _c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("add")) + " ")]) : _vm._e(), _vm.showRemove ? _c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": _vm.remove
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]) : _vm._e()];
      },
      proxy: true
    }])
  }, [_vm.isRegistrationAddress ? _c('div', {
    staticClass: "pt-2 pr-2 pl-2"
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.registration.registrationAddress.street')
    },
    model: {
      value: _vm.reportDto.registrationResults.street,
      callback: function callback($$v) {
        _vm.$set(_vm.reportDto.registrationResults, "street", $$v);
      },
      expression: "reportDto.registrationResults.street"
    }
  })], 1), _c('v-col', {
    staticClass: "pr-1",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.registration.registrationAddress.city')
    },
    model: {
      value: _vm.reportDto.registrationResults.city,
      callback: function callback($$v) {
        _vm.$set(_vm.reportDto.registrationResults, "city", $$v);
      },
      expression: "reportDto.registrationResults.city"
    }
  })], 1), _c('v-col', {
    staticClass: "pl-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.registration.registrationAddress.zip'),
      "rules": _vm.isNumberRule,
      "type": "number"
    },
    model: {
      value: _vm.reportDto.registrationResults.zipCode,
      callback: function callback($$v) {
        _vm.$set(_vm.reportDto.registrationResults, "zipCode", $$v);
      },
      expression: "reportDto.registrationResults.zipCode"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }